<template>
  <page-outline :title="$t('common.flux_rtp')">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed" class="mb-3">
        <div class="position-absolute top-44px w-100">
          <cm-messages-filter
            v-if="serviceId === services.PAYMENTS && mode === 2"
            class="researchfilter position-relative z-10"
            isPayments
            received
            filterType="group"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
          <cm-messages-filter
            v-else
            class="researchfilter position-relative z-10"
            isPayments
            received
            filterType="list"
            :mode="this.mode"
            @extractCSV="extractCSV()"
            @applyFilter="applyFilter($event)"
            @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
        </div>
      </div>
      <div class="listPage">
        <b-row
          class="form-group justify-content-start"
          v-if="false"
        >
          <b-col cols="1">
            <b-button
              :aria-label="$t('common.rfrsh')"
              class="btn"
              :disabled="activateSpinner"
              @click="refreshInbox()"
            >
              <i class="fa-light fa-rotate-right"></i>
              <span class="fab-label">{{ $t("common.rfrsh") }}</span>
            </b-button>
          </b-col>
          <b-col cols="1" offset-md="6">
            <b-button variant="primary"
              :disabled="activateSpinner"
              @click="extractCSV()"
            >
              <i class="fa-light fa-upload"></i>
              <span class="fab-label">{{ $t("common.extract") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  v-if="serviceId === services.PAYMENTS && mode === 2"
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="group"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV()"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
                <cm-messages-filter
                  v-else
                  class="researchfilter position-relative z-10"
                  isPayments received
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @extractCSV="extractCSV()"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="1"
                  @refreshInbox="refreshInbox()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :class="customMobileLayoutStyle"></div>
            </div>

            <spinner v-if="activateSpinner" class="mt-3"></spinner>
            <div v-else>
              <span v-if="items.length" class="font-weight-bold">{{ $t('common.results_payments_desc') +  paginationObject.nbResultsTotal}}</span>
              <b-table
                class="mt-3"
                hover
                relative
                responsive
                v-if="items.length"
                :key="keyTableFlux"
                :items="items"
                :fields="fields"
                selectable select-mode="single" @row-selected="seeDetails"
              >
                <template #cell(direction)="data">
                  <div v-if="data.value === 'Request'"><i class="fa-solid fa-right text-blue"></i></div>
                  <div v-else><i class="fa-solid fa-left text-success"></i></div>
                </template>
                <template #cell(dateTime)="data"><div class="cursor text-ellipsis">{{ data.value | formatDateTime }}</div></template>
              </b-table>
              <label v-else class="font-bold w-100 d-flex justify-content-center mt-3">{{ $t('common.no_result') }}</label>
            </div>
            <b-row class="mt-5">
              <b-col>
                <b-col cols="12">
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh"
                  ></cm-pagination>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment";

import PageOutline from "@/components/common/PageOutline.vue";

import MessagesFilter from "@/components/common/Filter";
import Spinner from "@/components/common/spinner.vue";
import Pagination from "@/components/common/pagination.vue";

import { errorMessageAlert } from "@/helpers/alert";
import { loadPage } from "@/helpers/routing";
import services from "@/helpers/services";
import { statusLabel } from "@/helpers/labels";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'

export default {
  name: "PaymentsFlux",
  components: {
    "cm-messages-filter": MessagesFilter,
    "spinner": Spinner,
    "page-outline": PageOutline,
    "cm-pagination": Pagination,
  },
  props: {
    direction: {
      default: "2",
      type: String,
    },
    modeFilter: {
      default: "3",
      type: String,
    },
  },
  data () {
    return {
      activateSpinner: false,
      filterConditions: {},
      items: [],
      keyTableFlux: false,
      mode: 3,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      scrollFlag: true,
      services: services,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t("common.appname"),
    };
  },
  computed: {
    canSeeSRTP () {
      return this.$engine.rights.rightIs('rtp_norm_srtp', true)
    },
    canSeeHRTP () {
      return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
    },
    fields () {
      return [
        { key: 'direction', label: this.$t('common.origin'), class: 'text-center' },
        { key: "dateTime", label: this.$t('common.dt'), class: "text-center" },
        { key: "debtorIdProvider", label: this.$t('requestToPay.provider_dbtor'), class: "text-center" },
        { key: "creditorBIC", label: this.$t('requestToPay.provider_crdtr'), class: "text-center" },
        { key: "endToEndId", label: this.$t('requestToPay.invoice_id'), class: "text-center word-break" },
        { key: "msgId", label: this.$t('requestToPay.msg_id'), class: "text-center word-break" }
      ]
    },
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    },
    customMobileLayoutStyle() {
      if (this.serviceId === services.PAYMENTS) {
        return "h-136px;"
      } else {
        return "h-90px;"
      }
    },
  },
  created() {
    this.$bus.$emit("change-mobile-header", {
      backLink: false,
      navbarInnerStyle: "justify-content:start;",
      navTitle: this.$t('common.flux_rtp'),
      returnUrl: "",
    });
    this.paginationObject["firstIndex"] = 1;
    this.paginationObject["maxResults"] = 15
    this.paginationObject["nbResultsTotal"] = 0;

    this.mode = parseInt(this.modeFilter, 10);
    let that = this;
    this.$engine.settings.set({ msgDirection: this.direction });

    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: 'direction', label: this.$t('common.origin'), class: 'text-center' },
        { key: "dateTime", label: this.$t('common.dt'), class: "text-center" },
        { key: "debtorIdProvider", label: this.$t('requestToPay.provider_dbtor'), class: "text-center" },
        { key: "creditorBIC", label: this.$t('requestToPay.provider_crdtr'), class: "text-center" },
        { key: "endToEndId", label: this.$t('requestToPay.invoice_id'), class: "text-center word-break" },
        { key: "msgId", label: this.$t('requestToPay.msg_id'), class: "text-center word-break" }
      ]
      that.onRefresh(false)
      that.pageCounter = 0
    })

    this.$bus.$off("refresh-cache-contacts");
    this.paginationObject['refresh'] = 'inbox-filtered'
    this.$bus.$off('inbox-filtered')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.on('refresh-inbox-on-seen', (refPays) => {
      that.updateInbox(refPays, true)
      loadPage(that, {url: '/payments/transaction-details/'})
    })
    this.$bus.$on('inbox-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false);
  },
  mounted() {
    this.$$(".infinite-scroll-preloader").remove();
    this.$bus.on("service:change", (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val);
    });
  },
  beforeDestroy() {
    let that = this;
    that.$engine.services.payments.filter.cleanFilterCondition();
  },
  methods: {
    applyFilter(filterConditions) {
      let that = this
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }
      this.filterConditions = filterConditions
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      if (this.canSeeSRTP && !this.canSeeHRTP) {
        filterConditions.standard = '1'
      } else if (!this.canSeeSRTP && this.canSeeHRTP) {
        filterConditions.standard = '2'
      } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
        filterConditions.standard = '0'
      }
      this.$engine.services.payments.updateStreamRTP(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.totalPayments
        that.paginationObject.nbResults = resp.data.payments.length
        requests = resp.data.payments
        that.updateItems(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })

    },
    extractCSV () {
      let firstLine =
      this.$t('common.origin') + ';' +
      this.$t('filter.msgId') + ';' +
      this.$t('common.endtoendid_label') + ';' +
      // this.$t('common.invc_ref') + ';' +
      this.$t('common.rsn') + ';' +
      this.$t('common.date_recpt') + ';' +
      // date reception to add
      this.$t('common.trtmnt_date') + ';' +
      this.$t('common.date_expr') + ';' +
      // QR Code to add
      // reason to chance to add
      // this.$t('common.rsn_new') + ';' +
      this.$t('common.amnt') + ';' +
      this.$t('common.crcy') + ';' +
      // amount to change
      // this.$t('common.amnt_new') + ';' +
      this.$t('filter.cntct_name') + ';' +
      this.$t('common.crdt_agnt') + ';' +
      // ultimate creditor to add
      this.$t('common.crdt_ibn') + ';' +
      this.$t('common.debtor_ibn_used') + ';' +
      this.$t('common.debtor_name_long') + ';' +
      this.$t('common.status.status_label') + ';' +
      ' \r\n'

        let lines = ''
        let that = this


        this.paginationObject['firstIndex'] = 1
        let filterConditions
        if (this.filterConditions) {
          filterConditions = this.filterConditions
        } else if (Object.keys(this.$engine.services.payments.filter.getDefaultFilter()).length > 0) {
          filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
        } else {
          filterConditions = this.$engine.services.payments.filter.getConditionObject()
        }
        this.$engine.services.payments.updateStreamRTP(
            this.direction,
            this.paginationObject.maxResults,
            this.paginationObject.firstIndex,
            filterConditions
        ).then(resp => {
          let inboxMessagesCSV = {}
          inboxMessagesCSV = resp.data.payments

          for (let datas in inboxMessagesCSV) {
            let origin = inboxMessagesCSV[datas].direction === '1' ? that.$i18n.t('common.snt') : that.$i18n.t('common.rcvd')
            let msgId = inboxMessagesCSV[datas].msgId
            let endToEndId = inboxMessagesCSV[datas].endToEndId
            // let invoiceRef = inboxMessagesCSV[datas].endToEndId
            let reason = inboxMessagesCSV[datas].reason
            let receptionDate = inboxMessagesCSV[datas].dateTime
            let trtmnt_date = ''
            if (inboxMessagesCSV[datas].acceptedRequestedExecutionDatetime) {
              trtmnt_date = inboxMessagesCSV[datas].acceptedRequestedExecutionDatetime
            } else if (inboxMessagesCSV[datas].requestedExecutionDate) {
              trtmnt_date = inboxMessagesCSV[datas].requestedExecutionDate
            }
            trtmnt_date = moment(trtmnt_date).format(that.$i18n.t('common.datepicker_format_date') + 'hh:mm:ss')
            let exp_date = ''
            if(inboxMessagesCSV[datas].requestedExpirationDate) {
              exp_date = inboxMessagesCSV[datas].requestedExpirationDate
              exp_date = moment(exp_date).format(that.$i18n.t('common.datepicker_format_date') + 'hh:mm:ss')
            }
            let amnt = ''
            if (inboxMessagesCSV[datas].creditNoteAmount) {
              amnt += parseFloat(inboxMessagesCSV[datas].creditNoteAmount).toFixed(2).toString()
            } else {
              if (inboxMessagesCSV[datas].amountResponse) {
                amnt += parseFloat(inboxMessagesCSV[datas].amountResponse).toFixed(2).toString()
              } else if (inboxMessagesCSV[datas].Amount) {
                amnt += parseFloat(inboxMessagesCSV[datas].Amount.replace('-', '')).toFixed(2).toString()
              } else {
                amnt += parseFloat(inboxMessagesCSV[datas].amount).toFixed(2).toString()
              }
            }
            let currency = inboxMessagesCSV[datas].currency
            // let amountToChange
            // let newAmount

            let correspondant_name = ''
            if (inboxMessagesCSV[datas].debtorName === undefined || inboxMessagesCSV[datas].debtorName === '') {
              correspondant_name = '-'
            } else if (inboxMessagesCSV[datas].direction === '1') {
              correspondant_name = inboxMessagesCSV[datas].debtorName
            } else {
              correspondant_name = inboxMessagesCSV[datas].creditorName
            }
            let creditorAgent = inboxMessagesCSV[datas].creditorBIC
            // let ultimateCreditor
            let creditor_iban = inboxMessagesCSV[datas].creditorBankAccount
            let debtor_iban = inboxMessagesCSV[datas].debtorBankAccount
            let debtor_name = inboxMessagesCSV[datas].debtorName
            let statusTrad = 'common.status.rtp.' + inboxMessagesCSV[datas].status
            let status = that.$i18n.t(statusTrad) === statusTrad ? that.$i18n.t('common.status.unknown') : that.$i18n.t('common.status.rtp.' + inboxMessagesCSV[datas].status)



            lines += origin + ';' +
            msgId + ';' +
            endToEndId + ';' +
            reason + ';' +
            receptionDate + ';' +
            trtmnt_date + ';' +
            exp_date + ';' +
            amnt + ';' +
            currency + ';' +
            correspondant_name + ';' +
            creditorAgent + ';' +
            creditor_iban + ';' +
            debtor_iban + ';' +
            debtor_name + ';' +
            status + '\r\n'
          }

          let data = firstLine + lines
          that.$f7.hidePreloader()
          const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
          const downloadLink = document.createElement('a')
          let today = moment()
          const fileName = that.$t('common.flux_rtp') + '_' + today.unix() + '.csv'
          if (
          that.$f7.device.os === 'android' ||
          that.$f7.device.os === 'ios'
          ) {
            downloadFileWithDefinedHeaders(that, fileName, linkSource)
          } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
          }
          that.$f7.alert('', that.$i18n.t('common.exprt_succ'))
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {
        let status_label = statusLabel(this.$i18n, requests[i].status, requests[i].negotStatus, requests[i].direction)

        let direction = ''
        if(requests[i].direction === '1') {
          direction = 'Request'
        } else {
          direction = 'Response'
        }

        let date = requests[i].dateTime

        let result = {
          id: requests[i].id,
          direction: direction,
          dateTime: date,
          status_label: status_label,
          creditorBIC: requests[i].creditorBIC,
          debtorIdProvider: requests[i].debtorIdProvider,
          endToEndId: requests[i].endToEndId,
          msgId: requests[i].msgId,
          details: requests[i]
        }
        this.items.push(result)
      }
    },
    onRefresh(noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions
      filterConditions = this.$engine.services.payments.filter.getConditionObject()
      if (this.canSeeSRTP && !this.canSeeHRTP) {
        filterConditions.standard = '1'
      } else if (!this.canSeeSRTP && this.canSeeHRTP) {
        filterConditions.standard = '2'
      } else if (!this.canSeeSRTP && !this.canSeeHRTP) {
        filterConditions.standard = '0'
      }
      this.$engine.services.payments.updateStreamRTP(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let requests = {}
          that.paginationObject.nbResultsTotal = resp.data.totalPayments
          that.paginationObject.nbResults = resp.data.payments.length
          requests = resp.data.payments

          that.updateItems(requests)
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
          that.activateSpinner = false
        }).catch(error => {
          that.activateSpinner = false
          errorMessageAlert(error, that)
        })
    },
    refreshInbox () {
      this.onRefresh()
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          // this.attachInfinit()
        }
      } else {
        // this.detachInfinit()
      }
    },
    seeDetails (items) {
      this.keyTableFlux = !this.keyTableFlux
      this.$engine.services.payments.idRequest = items[0].id
      loadPage(this, {url: '/payments/request-details/' + items[0].id})
    }
  },
};
</script>
